export default class preincidenciasService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/preincidencias',
			"id": '/api/preincidencias/:id',
			"new": '/api/preincidencias',
			'delete': '/api/preincidencias/:id',
			"modificar": '/api/preincidencias'
		};
	}

	getAll(params){
		let url = this.baseUrl + this.routes.all;
		var config = {};		
		if (params !== undefined) {
			if (typeof params == 'string') {				
				config.params = {};
				config.params.string = params;
			}else{				
				config.params = {};
				for (var element in params) {
					config.params[element] = params[element];
				}
				config.params.proyectos = params.proyectos;
			}
		}		
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId.id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	destruct(objId){
		let url = this.baseUrl + this.routes.delete;
		let idRoute = this.routes.delete.replace(':id', objId);
		this.http.delete();
	}

    modificar(objId) {

        let url = this.baseUrl + this.routes.modificar;
		return this.http.put(url,objId);
	}

}



// WEBPACK FOOTER //
// ./app/js/services/preincidenciasService.js